import { render, staticRenderFns } from "./AfterRegister.vue?vue&type=template&id=02034f76&scoped=true&"
import script from "./AfterRegister.vue?vue&type=script&lang=js&"
export * from "./AfterRegister.vue?vue&type=script&lang=js&"
import style0 from "./AfterRegister.vue?vue&type=style&index=0&id=02034f76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02034f76",
  null
  
)

export default component.exports